<template>
  <div class="btngroup-single">
      <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'btngroup-single',
  props: ['variant', 'size', 'routerName', 'href']
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";

.btngroup-single {
  width: 100%;
  text-align: center;
  margin-right: auto;
  margin-left: auto;
  &.-margin-lg {
    margin: 40px 0 60px;
    @include mq-up(md) {
      margin: 60px 0 120px;
    }
  }
  &.-margin-sm {
  margin: 20px auto 20px;
    @include mq-up(md) {
      margin: 30px auto 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/button/BtngroupSingle.vue